import ProjectCard from './ProjectCard';

import '../styles/Experience.css';
export default function Experience() {
    return (
        <div className="experience">
            <div className='experience__container'>
                <div className='experience__header'>
                    <h1>Experience</h1>
                </div>
                <div className='experience__body'>
                    <div className='experience__item'>
                        <div className='experience__title'>
                            <h2>Software Engineer, Intern</h2>
                            <div className='experience__date'>
                                <p>Gestionadora de Créditos</p>
                                <p>02/2024 - 06/2024</p>
                            </div>
                        </div>
                        <div className='experience__details'>
                            <ul>
                                <li>Developed a virtual assistant to optimize document writing for the legal department enabling end users to generate a
                                new document in less than 1 minute.</li>
                                <li>Improved assistant capabilities by implementing Retrieval-Augmented Generation (RAG) with Large Language Models
                                (LLMs) using LangChain and Python, achieving over 95% accuracy in text generation performance evaluations, as 
                                measured by BLEU scores and semantic accuracy metrics.</li>
                                <li>Developed a responsive web user interface with Next.js and CSS, integrating a RESTful API built with Flask, while
                                optimizing data retrieval with Milvus vector database and ensuring efficient and fast file access using AWS S3 for
                                seamless user interaction.</li>
                                <li>Applied Scrum methodology across all phases of the project lifecycle (analysis, design, implementation, and testing)
                                resulting in improved workflow efficiency, while actively participating in sprint planning, daily stand-ups, and mob
                                programming calls.</li>
                                <li>Authored comprehensive technical documentation for the codebase, API, and project architecture enhancing main-
                                tainability and supporting efficient onboarding for future developers.</li>

                            </ul>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div className='projects__container'>
                <div className='projects__header'>
                    <h1>Projects</h1>
                </div>
                <div className='projects__body'>
                    <ProjectCard project={{
                        name: 'Movies CRUD Web Application',
                        date: '2024',
                        description: 'Designed and implemented a full-stack web application for managing movies data, featuring a dynamic React.js frontend with UI designs prototyped in Figma. Developed backend services using Node.js and Express, integrated with a MySQL database for efficient data handling. Implemented robust CRUD functionality to streamline data management operations.',
                        url: 'https://github.com/ALEXUSCR-27/Cinex-Manager'
                    }}
                        
                    />
                    <ProjectCard project={{
                        name: 'Amazon Data ETL Pipeline',
                        date: '2024',
                        description: 'Developed an automated ETL pipeline using Apache Airflow and Docker to extract and transform Amazon products data from CSV files, deriving insights on categories, subcategories, prices, ratings, and reviews before loading it into a PostgreSQL database using Supabase services. Designed dynamic visualizations in Google Looker Studio to identify trends and perform statistical analysis.',
                        url: 'https://github.com/ALEXUSCR-27/Amazon-Data-ETL'
                    }}
                        
                    />
                    <ProjectCard project={{
                        name: 'Book Genre Prediction System',
                        description: 'Developed a machine learning solution to classify book genres using an Amazon Books dataset. Preprocessed and cleaned data with Pandas to ensure accuracy and consistency for model training. Leveraged Matplotlib and Seaborn to visualize key insights on book ratings, pricing trends, and author rankings. Trained a Support Vector Machine (SVM) model for genre prediction and implemented a Gradio-based user interface for real-time classification. Evaluated model performance using Recall and F1-Score metrics, achieving reliable and actionable results.',
                        url: ''
                    }}
                        
                    />
                </div>
            </div>
        </div>
    )
}